module.exports = __webpack_public_path__ + "img/1.b2f7d82a.png";